import {
  format as formatDateFns,
  parseISO,
  isValid,
  formatDistanceStrict
} from "date-fns";
import moment from "moment-timezone";

// moment.tz.guess() is expensive and the guessed zone is stable for the session, so compute it
// once at module load instead of on every timezone-formatted render.
const GUESSED_TIMEZONE = moment.tz.guess();

const DateFormatter = ({
  value,
  format = "MMM d, yyyy",
  outputFormat = null,
  showTimeAgo = false,
}) => {
  let parsedDate;

  if (!value)
    return outputFormat === "string" ? "Error" : <>Error</>;

  if (value instanceof Date) {
    parsedDate = value;
  } else if (typeof value === "string") {
    parsedDate = moment.utc(value).toDate();
  } else if (typeof value === "number") {
    const dateStr = value.toString();
    const year = dateStr.slice(0, 4);
    const month = dateStr.slice(4, 6);

    if (dateStr.length === 8) {
    const day = parseInt(dateStr.slice(6, 8), 10);
    parsedDate = new Date(year, month-1, day); // local time
  } else if (dateStr.length === 6) {
    parsedDate = new Date(year, month-1, 1);
  } else {
    parsedDate = new Date(value); // fallback
  }

  } else {
    return <>Invalid date</>;
  }

  if (!isValid(parsedDate)) return <>Invalid date</>;

  let formattedDate;

  if (showTimeAgo) {
    const now = new Date();

    formattedDate = formatDistanceStrict(parsedDate, now, {
      addSuffix: true,
      roundingMethod: "floor",
    });
  } else {
    const usesTimezone = /z|Z/.test(format);
    if (usesTimezone) {
      formattedDate = moment(parsedDate).tz(GUESSED_TIMEZONE).format(format);
    } else {
      formattedDate = formatDateFns(parsedDate, format);
    }
  }

  return outputFormat === "string" ? formattedDate : <>{formattedDate}</>;
};

export default DateFormatter;
